import React from "react";
import PropTypes from "prop-types";
import { WalletBtns, WalletContainer, WalletHeader } from "../walletStyles";
import { Box, Typography } from "@mui/material";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BsBank, BsBank2 } from "react-icons/bs";

const Channel = ({ onCloseModal, onSelect, paymentChannel, onProceed, onReturn }) => {
	return (
		<WalletContainer>
			<>
				<WalletHeader
					headerText='Payment Method'
					context='Select payment method to proceed'
					onCloseModal={onCloseModal}
				/>
				<Box
					display='flex'
					marginTop={3}
					flexDirection='column'
					border='1px solid gray'
					borderRadius={2}
					paddingY={1.5}>
					<PaymentMethod
						text='Paga Bank Transfer'
						icon={<BsBank />}
						onSelect={() => onSelect("paga-bank-transfer")}
						isSelected={paymentChannel === "paga-bank-transfer"}
					/>
					<PaymentMethod
						text='Providus Bank Transfer'
						icon={<BsBank2 />}
						onSelect={() => onSelect("providus-bank-transfer")}
						isSelected={paymentChannel === "providus-bank-transfer"}
					/>
				</Box>
				<WalletBtns
					greenBtnClick={onProceed}
					whiteBtnClick={onReturn}
					isGreenBtnDisabled={paymentChannel === ""}
				/>
			</>
		</WalletContainer>
	);
};

export default Channel;

Channel.propTypes = {
	onCloseModal: PropTypes.func,
	onSelect: PropTypes.func,
	paymentChannel: PropTypes.string,
	onProceed: PropTypes.func,
	onReturn: PropTypes.func,
};

const PaymentMethod = ({ icon, text, onSelect, isSelected }) => {
	return (
		<Box
			display='flex'
			justifyContent='space-between'
			alignItems='center'
			color='#00525d'
			padding={2}
			sx={{ background: isSelected ? "#EEF2F3" : "white", cursor: isSelected ? "default" : "pointer" }}
			onClick={onSelect}>
			<Box display='flex' alignItems='center' gap={2}>
				{icon}
				<Typography sx={{ fontSize: "14px", fontWeight: 500 }}>{text}</Typography>
			</Box>
			<MdKeyboardArrowRight size={24} />
		</Box>
	);
};

PaymentMethod.propTypes = {
	icon: PropTypes.object,
	text: PropTypes.string,
	onSelect: PropTypes.func,
	isSelected: PropTypes.bool,
};
